import { useMemo } from 'react';
import classnames from 'classnames';

import { Tag, TagStyle } from '@hh.ru/magritte-ui';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';

export enum SimpleTagType {
    AutoInvite = 'autoInvite',
    AutoSurveyInProgress = 'autoSurveyInProgress',
    CrossPlatform = 'crossPlatform',
    FromVr = 'fromVr',
    WannaWork = 'wannaWork',
    FromClickmeCpa = 'fromClickmeCpa',
}

const TrlKeys = {
    [SimpleTagType.AutoInvite]: 'employer.vacancyResponses.tag.autoInviteTag',
    [SimpleTagType.AutoSurveyInProgress]: 'employer.vacancyResponses.tag.autoSurveyInProgress',
    [SimpleTagType.CrossPlatform]: 'search.resume.crossPostedLabel.fromZP',
    [SimpleTagType.FromVr]: 'employer.vacancyResponses.tag.vr',
    [SimpleTagType.WannaWork]: 'resume.snippet.tag.wannaWork',
    [SimpleTagType.FromClickmeCpa]: 'resume.snippet.tag.fromClickmeCpa',
};

const specialStyleTags = [
    SimpleTagType.AutoInvite,
    SimpleTagType.AutoSurveyInProgress,
    SimpleTagType.FromVr,
    SimpleTagType.FromClickmeCpa,
];

const SimpleTag: TranslatedComponent<{ type: SimpleTagType }> = ({ type, trls }) => {
    const tagStyleType: TagStyle = useMemo(() => {
        if (specialStyleTags.includes(type)) {
            return 'special';
        } else if (type === SimpleTagType.CrossPlatform) {
            return 'warning';
        } else if (type === SimpleTagType.WannaWork) {
            return 'negative';
        }

        return 'neutral';
    }, [type]);

    return (
        <span
            data-qa={classnames({
                [`response_tag_autoInvite`]: type === SimpleTagType.AutoInvite,
                [`response_tag_autoSurveyInProgress`]: type === SimpleTagType.AutoSurveyInProgress,
                [`response_tag_from_vr`]: type === SimpleTagType.FromVr,
                [`resume-serp_resume-wantwork`]: type === SimpleTagType.WannaWork,
                [`response_tag_from_clickme_cpa`]: type === SimpleTagType.FromClickmeCpa,
            })}
        >
            <Tag style={tagStyleType}>{trls[TrlKeys[type]]}</Tag>
        </span>
    );
};

export default translation(SimpleTag);
